import { render, staticRenderFns } from "./LienKetNganHangSHBList.vue?vue&type=template&id=126abe8c&"
import script from "./LienKetNganHangSHBList.vue?vue&type=script&lang=js&"
export * from "./LienKetNganHangSHBList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports